import defaultUser from '../utils/default-user';
import axios from '../utils/axiosConfig'

interface LoginCredentials {
  username: string;
  password: string;
}

interface UserResponse {
  success: boolean;
  message: string;
  data: {
    userLoginResponse: {
      id: string;
      nama: string;
      email: string;
    }
    token: string;
  };
}

export const login = async (credentials: LoginCredentials): Promise<UserResponse> => {
  try {
    const response = await axios.post<UserResponse>("/api/v1/auth/signin", credentials);
    // const response = await axios.post<UserResponse>("/api/login", credentials);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || "Failed to login, please try again."
    );
  }
};

export async function signIn(email: string, password: string) {
  try {
    // Send request
    // console.log(email, password);

    return {
      isOk: true,
      data: defaultUser
    };
  }
  catch {
    return {
      isOk: false,
      message: "Authentication failed"
    };
  }
}

export async function getUser() {
  try {
    // Send request

    return {
      isOk: true,
      data: defaultUser
    };
  }
  catch {
    return {
      isOk: false
    };
  }
}

export async function createAccount(email: string, password: string) {
  try {
    // Send request
    // console.log(email, password);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to create account"
    };
  }
}

export async function changePassword(email: string, recoveryCode?: string) {
  try {
    // Send request
    // console.log(email, recoveryCode);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to change password"
    }
  }
}

export async function resetPassword(email: string) {
  try {
    // Send request
    // console.log(email);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to reset password"
    };
  }
}
